<script>
import { productTypeList, productTypeFilter } from '@utils/filter-value-to-text'
const initData = () => {
  return {
    productType: '',
    productPriceIds: [],
  }
}

export default {
  filters: {
    productTypeFilter,
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => initData(),
    },
  },
  data() {
    return {
      submitData: Object.assign(initData(), this.defaultValue),
      productTypeList: Object.freeze(productTypeList),
      fetchingProducts: false,
      filterText: '',
      productList: [],
      productProps: {
        label: 'title',
        disabled: (data, node) => {
          return node.level === 1
        },
        isLeaf: (data, node) => {
          return node.level !== 1
        },
      },
    }
  },
  computed: {
    submitRules() {
      return {
        productType: [
          {
            required: true,
            message: '請指定此預付方案可適用的項目類型',
            trigger: 'change',
          },
        ],
      }
    },
    isEditMode() {
      return this.defaultValue.id
    },
  },
  watch: {
    'submitData.productType': {
      handler(value) {
        if (value) return this.fetchProducts()
      },
      immediate: true,
    },
    filterText(val) {
      this.$refs.prices.filter(val)
    },
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    changeSelectPrice() {
      this.submitData.productPriceIds = this.$refs.prices.getCheckedKeys()
    },
    filterProduct(value, data) {
      if (!value) return true
      return data.title.indexOf(value) !== -1
    },
    async fetchProductPrices(node, resolve) {
      const { id: productId } = node.data
      if (!productId) return
      return resolve(
        await this.$store.dispatch('product/fetchPrices', {
          productId,
          query: {
            size: 1, // NOTE: 僅限使用人數為 1 的購買方案
          },
        })
      )
    },
    async fetchProducts() {
      this.fetchingProducts = true
      const { items: originalProduct } = await this.$store.dispatch(
        'product/fetchList',
        {
          type: this.submitData.productType,
          paginate: 0,
        }
      )
      this.productList = Object.freeze(
        originalProduct.map((product) => {
          return {
            ...product,
            title: product.name,
          }
        })
      )
      this.fetchingProducts = false
    },
  },
}
</script>

<template>
  <div>
    <el-form
      ref="form"
      :model="submitData"
      :rules="submitRules"
      :validate-on-rule-change="false"
      label-position="top"
      class="el-form--floating"
      autocomplete="off"
    >
      <template v-if="isEditMode">
        <h4 class="form-block-title">此方案適用的項目類型為</h4>
        {{ submitData.productType | productTypeFilter }}
        <h4 class="form-block-title">適用的購買方案</h4>
      </template>
      <template v-else>
        <h4 class="form-block-title">1. 請先選擇適用的項目類型</h4>
        <p>預付方案僅能套用單一項目類型，儲存後將無法變更</p>
        <el-form-item prop="productType">
          <el-select v-model="submitData.productType" @change="fetchProducts">
            <el-option
              v-for="(type, typeValue) in productTypeList"
              :key="typeValue"
              :label="type.name"
              :value="typeValue"
            ></el-option>
          </el-select>
        </el-form-item>

        <h4 v-if="submitData.productType" class="form-block-title"
          >2. 請選擇適用的購買方案</h4
        >
      </template>
      <el-form-item v-if="submitData.productType" prop="productPriceIds">
        <div :class="$style.searchbar">
          <el-input
            v-model="filterText"
            placeholder="輸入關鍵字篩選項目"
          ></el-input>
        </div>
        <el-tree
          v-show="submitData.productType"
          ref="prices"
          v-loading="fetchingProducts"
          element-loading-text="正在取得此類型之所有項目"
          :class="$style['parent-checkbox-hide']"
          :default-checked-keys="submitData.productPriceIds"
          :data="productList"
          :props="productProps"
          :load="fetchProductPrices"
          :filter-node-method="filterProduct"
          node-key="id"
          check-strictly
          lazy
          show-checkbox
          @check-change="changeSelectPrice"
        ></el-tree>
      </el-form-item>
    </el-form>
  </div>
</template>
<style lang="scss" module>
.searchbar {
  margin-bottom: 15px;
}
:global {
  :local(.parent-checkbox-hide) {
    &.el-tree > .el-tree-node > .el-tree-node__content > .el-checkbox {
      display: none;
    }
  }
}
</style>
